(function () {
  window.okdoTrack = function (eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      okdo: payload || {}
    });

    if (window.fbq) window.fbq('trackCustom', eventName, payload || {});
    if (window.ttq && window.ttq.track) window.ttq.track(eventName, payload || {});
  };

  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-okdo-track]');
    if (!target) return;

    window.okdoTrack(target.getAttribute('data-okdo-track'), {
      label: target.textContent.trim(),
      href: target.getAttribute('href') || ''
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-okdo-form]');
    if (!form) return;
    if (!form.getAttribute('action')) {
      event.preventDefault();
      var status = form.querySelector('[data-okdo-form-status]');
      if (status) status.textContent = 'Thanks. This inquiry form is ready to connect to Shopify Forms, Klaviyo, Omnisend, HubSpot or another form tool.';
    }
    window.okdoTrack(form.getAttribute('data-okdo-form'), {
      form_id: form.id || ''
    });
  });

  document.addEventListener('submit', function (event) {
    if (event.target.matches('form[action*="/cart/add"]')) {
      window.okdoTrack('okdo_add_to_cart', { source: 'product_form' });
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('a[href*="/checkout"], button[name="checkout"]')) {
      window.okdoTrack('okdo_begin_checkout', { source: 'checkout_cta' });
    }
  });
})();
